export const scrollBy = ($target, top, duration = 1500) => {
  $target.animate({
    scrollTop: top,
  }, duration);
};
